export const SeamlessLogisticServiceData = [
  {
    imageName: 'cml/track-package-icon',
    header: 'Track package',
    description: 'Get real-time visibility into your shipment’s status',
  },
  {
    imageName: 'cml/schedule-ship-icon',
    header: 'Schedule Shipments',
    description: 'Choose your preferred delivery time',
  },
  {
    imageName: 'cml/swift-icon',
    header: 'Swift Delivery',
    description: 'Receive your shipments within 3-4 days',
  },
];
